import LOGO_US_PHARMA from "./editor/media/imgs/logo_US_Pharma.png";

// const INS = "qureal"; // qureal, c_lccia, c_us_pharma
// const INS = process.env.REACT_APP_INS || "qureal";
const INS = "qureal";

// let BASE_URL = "http://156.67.217.219:2101/";
let BASE_URL = "https://api.qureal.com/";
let LOGIN_URL = "http://app.qureal.com";
let STATIC_ROOT = "https://api.qureal.com/assets/";
let VIEWER_URL = "https://show.qureal.com/";

let EDITOR_CONFIGS = {
    logo: null,
    home: true,
    home_url: "http://app.qureal.com",
    view: true,
    fullscreen: true,
    preview: true,
    save: true,
    export: true,
    publish: true,
    page_template: true,
    creation_template: true,
    action: null,
    //tabs
    seo: true,
    graphics: true,
};

if (INS === "c_us_pharma") {
    // BASE_URL = "http://156.67.217.219:3102/";
    BASE_URL = "https://apiuspharma.qureal.com/";
    // LOGIN_URL = "http://localhost:3001";
    LOGIN_URL = "http://app.uspharma.in";
    STATIC_ROOT = "http://api.qureal.com/assets_us_pharma/";
    VIEWER_URL = "https://show.qureal.com/c/us_pharma/";
    EDITOR_CONFIGS = {
        ...EDITOR_CONFIGS,
        logo: LOGO_US_PHARMA,
        action: {
            text: "Submit",
            icon: "arrow right",
            color: "royalblue",
            confirm: {
                title: "Sumbit to designers",
                description: "Once submitted, you can't edit it",
                btnPositive: "Yes",
                btnNegative: "Cancel",
                positiveAction: {
                    // type: "update",
                    type: "publish",
                    additional_payload: {
                        status: "completed",
                    },
                    redirect: false,
                    // redirect: LOGIN_URL,
                },
            },
            field: "submitted",
            value: true,
        },
        seo: false,
        graphics: false,
    };
} else if (INS === "test") {
    BASE_URL = "https://testapi.qureal.com/";
    LOGIN_URL = "http://localhost:3001";
    STATIC_ROOT = "http://api.qureal.com/assets_us_pharma/";
    VIEWER_URL = "https://show.qureal.com/c/test/";
}

// export const BASE_URL = "http://156.67.217.219:2101/";

export const EXTERNAL_URL = "http://localhost:5000/";

// export const VIEWER_URL = "http://show.qureal.com/";

// export const STATIC_ROOT = "http://api.qureal.com/passets/";
// export const STATIC_ROOT = "http://156.67.217.219:2101/passets/";

export { INS, BASE_URL, LOGIN_URL, STATIC_ROOT, VIEWER_URL, EDITOR_CONFIGS };
